import { Stack, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { AdHocIssuesTable } from './AdHocIssuesTable';

type IssuesAdHocTabProps = {
  initialIssueId?: number;
};

export const IssuesAdHocTab = ({ initialIssueId }: IssuesAdHocTabProps) => {
  const [subTab, setSubTab] = useState<'active' | 'archived'>('active');

  return (
    <Stack paddingTop={3} gap={2}>
      <Tabs
        value={subTab}
        onChange={(_, value) => setSubTab(value)}
        sx={{ borderBottom: '1px solid #eee' }}>
        <Tab label="Ad Hoc Issues" value="active" />
        <Tab label="Archived Ad Hoc Issues" value="archived" />
      </Tabs>
      {subTab === 'active' ? (
        <AdHocIssuesTable view="active" initialIssueId={initialIssueId} />
      ) : (
        <AdHocIssuesTable view="archived" />
      )}
    </Stack>
  );
};
